import {defaultKeywords} from "../keywords";

export const seoContentMapKo = {
        '/': {
            title: "Rodin - 이미지 기반 무료 AI 3D 모델 생성기 | Hyper3D",
            description: "AI를 통해 순식간에 멋진 3D 모델을 만드세요. 텍스트나 이미지를 활용해 쉽게 3D 모델을 생성하고, 지금 바로 창작 과정을 혁신하세요.",
            keywords: defaultKeywords,
            h1Text: "Rodin - 텍스트와 이미지를 활용한 무료 AI 3D 모델 생성기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/"
        },
        '/rodin': {
            title: "Rodin - 무료 AI 3D 모델 생성기 | Hyper3D",
            description: "AI를 통해 순식간에 멋진 3D 모델을 만드세요. 텍스트나 이미지를 활용해 쉽게 3D 모델을 생성하고, 지금 바로 창작 과정을 혁신하세요!",
            keywords: defaultKeywords,
            h1Text: "Rodin - 텍스트와 이미지를 활용한 무료 AI 3D 모델 생성기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/"
        },
        '/rodin/page': {
            title: "Rodin - AI 3D 모델 생성기",
            description: "AI를 통해 순식간에 멋진 3D 모델을 만드세요. 텍스트나 이미지를 활용해 쉽게 3D 모델을 생성하고, 지금 바로 창작 과정을 혁신하세요!",
            keywords: defaultKeywords,
            h1Text: "Rodin - 텍스트와 이미지를 활용한 무료 AI 3D 모델 생성기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요"
        },
        '/rodin/search': {
            title: "3D 모델 | Hyper3D",
            description: "fbx, obj, glb, usd 형식으로 쉽게 열람하고 무료로 다운로드하세요. 게임, VR/AR, 영상 제작, 3D 프린팅 등 다양한 용도로 활용 가능합니다.",
            keywords: defaultKeywords,
            h1Text: "Rodin - 텍스트와 이미지를 활용한 무료 AI 3D 모델 생성기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요"
        },
        '/rodin/tab/story': {
            title: "Rodin - 사용자 스토리 모음 | Hyper3D",
            description: "다양한 사용자 스토리를 살펴보고, Rodin이 예술가와 디자이너의 창작 과정을 어떻게 혁신하고 있는지 확인해보세요.",
            keywords: defaultKeywords,
            h1Text: "Rodin - 텍스트와 이미지를 활용한 무료 AI 3D 모델 생성기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/rodin/tab/story"
        },
        '/chatavatar': {
            title: "ChatAvatar - AI 3D 얼굴 에셋 생성기 | Hyper3D",
            description: "Hyper3D의 ChatAvatar는 텍스트 또는 이미지를 활용해 단 몇 분 만에 제작 준비가 완료된 초현실적인 PBR 텍스처 3D 얼굴 에셋을 생성합니다.",
            keywords: defaultKeywords,
            h1Text: "ChatAvatar - 3D 얼굴 에셋 생성기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/chatavatar"
        },
        '/imageto3d': {
            title: "ChatAvatar - AI 3D 얼굴 에셋 생성기 | Hyper3D",
            description: "Deemos Hyper3D의 ChatAvatar를 통해 텍스트나 이미지를 활용해 몇 분 만에 초현실적이고 제작 준비가 완료된 PBR 텍스처 3D 얼굴 에셋을 생성하세요.",
            keywords: defaultKeywords,
            h1Text: "ChatAvatar - 3D 얼굴 에셋 생성기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/chatavatar"
        },
        '/subscribe': {
            title: "가격 안내 | Hyper3D",
            description: "Hyper3D를 구독하여 독점 기능과 콘텐츠를 이용해보세요.",
            keywords: defaultKeywords + "Subscription, Hyper3D, Premium, Features",
            h1Text: "구독 - Hyper3D",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/subscribe"
        },
        '/api-dashboard': {
            title: "API 대시보드 | Hyper3D",
            description: "Hyper3D API 키를 관리하고 사용 통계를 모니터링하세요.",
            keywords: defaultKeywords + "API, Dashboard, Hyper3D, API Keys, Usage",
            h1Text: "API 대시보드",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/api-dashboard"
        },
        '/user/login': {
            title: "로그인 | Hyper3D",
            description: "Hyper3D 계정에 로그인하세요. 무료로 사용해보고 손쉽게 체험해보세요. 모델링, 텍스처링 등 다양한 분야에서 Hyper3D가 도와드립니다.",
            keywords: defaultKeywords + "Login, Hyper3D, User, Account",
            h1Text: "로그인",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/user/login"
        },
        '/signup': {
            title: "회원가입 | Hyper3D",
            description: "새로운 Hyper3D 계정을 만드세요. 무료로 사용하고 손쉽게 체험해보세요. 모델링, 텍스처링 등 다양한 분야에서 Hyper3D가 도와드립니다.",
            keywords: defaultKeywords + "Sign Up, Hyper3D, Register, Account",
            h1Text: "회원가입",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/signup"
        },
        '/legal/privacy': {
            title: "개인정보 처리방침 | Hyper3D",
            description: "Hyper3D의 개인정보 처리방침을 확인하고 데이터 처리 방식을 알아보세요.",
            keywords: defaultKeywords + "Privacy Policy, Hyper3D, Data Protection, Privacy",
            h1Text: "개인정보 처리방침",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/legal/privacy"
        },
        '/legal/terms': {
            title: "이용 약관 | Hyper3D",
            description: "Hyper3D의 이용 약관을 확인하세요. 이 약관은 Hyper3D 서비스 이용 시 적용되는 규정을 포함합니다.",
            keywords: defaultKeywords + "Terms of Service, Hyper3D, Terms, Conditions",
            h1Text: "이용 약관",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/legal/terms"
        },
        '/product/faq': {
            title: "자주 묻는 질문 | Hyper3D",
            description: "Hyper3D 제품 및 서비스에 대한 자주 묻는 질문과 답변을 확인하세요.",
            keywords: defaultKeywords + "FAQ, Hyper3D, Questions, Answers, Help",
            h1Text: "자주 묻는 질문",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/product/faq"
        },
        '/omnicraft': {
            title: "OmniCraft - 3D 도구 모음 | Hyper3D",
            description: "OmniCraft는 3D 아티스트, 게임 개발자, 디자이너 등을 위한 무료 온라인 3D 모델링 도구 모음입니다.",
            keywords: defaultKeywords + "HDRI Generator, image generator, image creator, omnicraft",
            h1Text: "이미지, 텍스트, 상상력을 바탕으로 나만의 가상 세계를 만들어보세요",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/omnicraft/"
        },
        '/omnicraft/hdri': {
            title: "HDRI 파노라마 생성기 - 나만의 가상 세계 만들기 | Hyper3D",
            description: "HDRI 파노라마 생성기를 활용해 몇 초 만에 나만의 가상 세계를 만들어보세요. 이미지, 텍스트, 상상력으로 구현할 수 있습니다.",
            keywords: defaultKeywords + "HDRI Generator, image generator, image creator, panorama generator, skybox generator",
            h1Text: "이미지, 텍스트, 상상력을 바탕으로 나만의 가상 세계를 만들어보세요",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/omnicraft/hdri"
        },
        '/omnicraft/formatcon': {
            title: "3D 포맷 변환기 - 무료 및 완전 오프라인 | Hyper3D",
            description: "3D 모델 파일을 드래그 앤 드롭만으로 obj, fbx, gltf, glb, usd 등 인기 있는 모든 형식으로 변환하세요. 무료로 사용 가능하며 완전히 오프라인으로 작동합니다.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "무료, 안전하고 완전히 오프라인으로 작동하는 3D 모델 변환기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/omnicraft/formatcon"
        },
        '/omnicraft/mesh': {
            title: "3D 메시 스컬팅 - 무료 및 완전 오프라인 | Hyper3D",
            description: "obj, fbx, 3ds, dxf, glb, usd 등 인기 있는 모든 형식을 지원하는 3D 메시 스컬팅 도구입니다. 무료로 사용 가능하며 완전히 오프라인으로 작동합니다.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "무료, 안전하고 완전히 오프라인으로 작동하는 3D 모델 변환기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/omnicraft/mesh"
        },
        '/omnicraft/search': {
            title: "Rodin 검색 - 3D 모델 검색 엔진 | Hyper3D",
            description: "이미지, 텍스트, 또는 3D 모델 자체를 사용해 Sketchfab, Daz3D, Rodin에서 원하는 3D 모델을 빠르게 검색할 수 있는 3D 검색 엔진입니다.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "Rodin 검색 - 3D 모델 검색 엔진",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/omnicraft/search"
        },
        '/omnicraft/viewer': {
            title: "3D 모델 뷰어 - 무료 및 완전 오프라인 | Hyper3D",
            description: "obj, fbx, stl, gltf, 3ds, dxf, ply, glb, usd 등 인기 있는 모든 형식을 지원하는 3D 모델 뷰어입니다.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "무료, 안전하고 완전히 오프라인으로 작동하는 3D 모델 뷰어",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/omnicraft/viewer"
        },
        '/omnicraft/texture': {
            title: "3D 텍스처 생성기 - 이미지로부터 3D 텍스처 생성 | Hyper3D",
            description: "이미지 기반의 사실적인 텍스처를 통해 모델, 게임, AR/VR, 예술 작품에 생동감을 부여할 수 있는 AI 텍스처 생성기입니다.",
            keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
            h1Text: "무료, 안전하고 완전히 오프라인으로 작동하는 3D 텍스처 생성기",
            image: "https://hyper3d.ai/assets/og-banner.webp",
            atl: "Hyper3D - Rodin & ChatAvatar로 3D 모델링을 혁신하세요",
            canonicalUrl: "https://hyper3d.ai/omnicraft/texture"
        },
}